var router = require('pjax').Router;
var tabForm = require('./form.js');
var index = require('./index.js');

router.get('tab/:any', tabForm);
router.get('tab', index);
